// extracted by mini-css-extract-plugin
export default {"title":"NetworkError_title__0l9Oa"};